export default (state, action) => {
  const newState = {...state};
  const {payload} = action;

  // get all keys managed by the dropdown filter
  const dropdownFilterKeys = Array.from(
    payload.categorizedFields.keys(),
    (cat) => cat.slug,
  );

  // remove all old state associated with dropdown filter
  for (const key of dropdownFilterKeys) {
    delete newState[key];
  }

  // add updated dropdown filter selections to state
  const selections = Array.from(payload.selected);
  for (const selection of selections) {
    const {id, slug} = selection;
    if (!newState.hasOwnProperty(slug)) {
      newState[slug] = [];
    }
    newState[slug].push(id);
  }

  const toRemove = ['page'];
  for (const param of toRemove) {
    if (newState.hasOwnProperty(param)) {
      delete newState[param];
    }
  }

  return newState;
};
